module.exports = __webpack_public_path__ + "img/bus_sidebar_img_3.90e9d049.svg";